import { createContext, useState } from "react";

const FormContext = createContext({});

export const FormProvider = ({ children }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [filterEntry, setFilterEntry] = useState(false);
  const [isLodaing, setIsLoading] = useState(false);
  const [openCNRecord, setOpenCNRecord] = useState(false);
  const [currentCNRecord, setCurrentCNRecord] = useState({});
  const [CNCall, setcnCall] = useState(false);

  return (
    <FormContext.Provider
      value={{
        isFormOpen,
        setIsFormOpen,
        filterEntry,
        setFilterEntry,
        isLodaing,
        setIsLoading,
        openCNRecord,
        setOpenCNRecord,
        currentCNRecord,
        setCurrentCNRecord,
        CNCall,
        setcnCall,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export default FormContext;
